<template>
  <div
    class="max-w-[300px] bg-white border border-gray-300 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700 grid grid-rows-[auto,1fr,auto]">
    <img class="rounded-t-lg" :src="imageSrc" :alt="altText" />
    <!-- Image superposée si adopté -->
    <img v-if="chatMaleAdopte" src="/src/assets/images/adopte.png" alt="Adopté" class="absolute  object-contain opacity-80"
    />
    <img v-if="chatFemelleAdoptee" src="/src/assets/images/adoptee.png" alt="Adoptée" class="absolute object-contain opacity-80"/>
    <!-- Image superposée si réservé -->
    <div class="px-3 py-5">
      <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white break-words">{{ title }}
        <span v-if="reserved === 'oui' && isMale" class="text-primaire"> (Réservé)</span>
        <span v-else-if="reserved === 'oui' && !isMale" class="text-primaire"> (Réservée)</span>
      </h5>
      <ul class="mb-3 font-normal text-gray-700 dark:text-gray-400">
        <li v-for="(detail, index) in details" :key="index">{{ detail }}</li>
        <li v-if="infoAdditionnel" class="text-gray-400 italic">{{ infoAdditionnel }}</li>
      </ul>
    </div>
    <slot></slot> <!-- Permet d'insérer un bouton personnalisé -->
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    imageSrc: {
      type: String,
      required: true,
    },
    altText: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    details: {
      type: Array,
      required: true,
    },
    reserved: {
      type: String,
      default: "non" //Par défaut, l'animal n'est pas réservé.
    },
    isMale: {
      type: Boolean,
      default: false, // Par défaut, l'animal n'est pas réservé.
    },
    chatFemelleAdoptee: {
      type: Boolean,
      default: false, // Par défaut, l'animal n'est pas adopté.
    },
    chatMaleAdopte: {
      type: Boolean,
      default: false, // Par défaut, l'animal n'est pas adopté.
    },
    infoAdditionnel: {
      type: String,
      default: '', // Par défaut, aucune information supplémentaire n'est fournie.
    }
  },
};
</script>

<style scoped>
img {
  aspect-ratio: 4 / 3;
  width: 100%;
  height: auto;
}

</style>